<template>
    <div class="header">
        <div class="head">
            <div class="official">欢迎浏览深圳市米饭儿数据科技有限公司官网</div>
            <div class="languages">
                <div class="language-left" v-t="'language'"></div>
                <div class="language-right">
                    <language></language>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import language from "@/components/language";

    export default {
        name: "Head",
        components: {
            language
        },
    }
</script>

<style scoped>
    .header{
        width: 100%;
        background-color: #111111;
    }
    .head{
        width: 1000px;
        height: 50px;
        margin: auto;
        position: relative;
        display: flex;
        justify-content: space-between;
    }
    .official{
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 800;
        /* color: white; */
        background: linear-gradient(to right, rgb(252, 252, 3), rgb(248, 219, 2) , rgb(238, 149, 6), rgb(246, 6, 6)); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
    }
    .languages{
        display: flex;
    }
    .language-left{
        font-size: 14px;
        display: flex;
        align-items: center;
        color: white;
    }
    .language-right{
        display: flex;
        align-items: center;
        margin-left: 8px;
    }
</style>